<template>
    <Paper header="Create job posting" tall padding>
        <div
            class="p-2 d-flex flex-column align-items-center justify-content-center white"
        >
            <h6 class="subtitle text-center color-white">
                {{ $t('findjobs.recruitmentModule.body') }}
            </h6>
            <div class="p-2">
                <BaseButton variant="secondary" @click="handleCreateJobClick">
                    {{ $t('findjobs.recruitmentModule.createJob') }}
                </BaseButton>
            </div>
        </div>
    </Paper>
</template>

<script>
import UniversityService from '~/services/UniversityService';

export default {
    name: 'RecruitmentModule',
    methods: {
        handleCreateJobClick() {
            window.open(
                `https://${UniversityService.getCurrentDomain()}.talentpanel.io`
            );
        },
    },
};
</script>

<style lang="scss" scoped></style>
